import { ReactNode } from "react";
import { CabinetHeader } from "../shared/Header";
import bg from "../../assets/background.jpg";

export const AuthShell = ({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
}) => (
  <div className="flex min-h-screen flex-col bg-night">
    <CabinetHeader/>

    <main
      className="flex flex-1 items-center justify-center bg-cover bg-center px-5 py-12"
      style={{ backgroundImage: `linear-gradient(to right, rgba(10,10,10,0.92) 40%, rgba(10,10,10,0.4)), url(${bg})` }}
    >
      <div className="card w-full max-w-md p-8">
        <h1 className="text-2xl font-bold text-white">{title}</h1>
        <p className="mt-2 text-sm text-neutral-400">{subtitle}</p>
        {children}
      </div>
    </main>
  </div>
);

export const AuthAlert = ({
  kind,
  message,
}: {
  kind: "error" | "info";
  message: string;
}) => (
  <p
    className={
      kind === "error"
        ? "rounded border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400"
        : "rounded border border-green-500/30 bg-green-500/10 px-4 py-3 text-sm text-green-400"
    }
  >
    {message}
  </p>
);

export const Field = ({
  label,
  ...props
}: { label: string } & React.InputHTMLAttributes<HTMLInputElement>) => (
  <label className="block">
    <span className="mb-2 block text-sm font-semibold text-neutral-300">
      {label}
    </span>
    <input className="input-dark" {...props} />
  </label>
);
